module.exports = __webpack_public_path__ + "images/audi_image5.85b0e157.png";